import { Component, Input } from '@angular/core';
import { Group } from '@icure/api';
import { CodeImportationDialogComponent } from '../dialogs/code-importation-dialog/code-importation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

interface ToolItem {
  id: string;
  description: string;
}

@Component({
  selector: 'ms-database-group-info-tools',
  templateUrl: './database-group-info-tools.component.html',
  styleUrl: './database-group-info-tools.component.scss',
  standalone: false,
})
export class DatabaseGroupInfoToolsComponent {
  @Input() selectedGroup: Group = {};

  public displayedColumns: string[] = ['description', 'btn'];
  public tools: ToolItem[] = [
    {
      id: 'codeUpload',
      description: 'Uploader les codes dans la base de données',
    },
  ];

  constructor(private dialog: MatDialog) {}

  public launchTool(tool: ToolItem): void {
    if (tool.id === 'codeUpload') {
      this.dialog.open(CodeImportationDialogComponent, {
        data: { toolType: tool, selectedGroup: this.selectedGroup },
        height: '700px',
        width: '1000px',
      });
    }
  }
}
